<template lang="pug">
  div.body.body-table.ierarchy-locations-table
    div.table-choose-panel
      div.toolbar-table
        div.select.list Населенные пункты

      e-table-inner(
        v-if="fields.id"
        tableWrapperClass="table"
        class="table--half"
        :visibleColumns="localityVisibleColumns"
        :itemsEndpoint="endpointLocalityList"
        :enableInnerPagination="false"
        :showRemoveConfirmation="false"
        ref="localityTable"
        :showDeleteButton="false"
      )
        div(slot="name" slot-scope="props")
          div(v-if="props.row.has_children")
            div(
              v-if="!isOpened(props.row)"
              :class="getItemClass(props.row)"
              @click.stop.prevent="openChild(props.row)"
            ).item.with-actions.close
              span.arrow
              span {{props.row.name}}
            div(
              v-else
              :class="getItemClass(props.row)"
              @click.stop.prevent="closeChild(props.row)"
            ).item.with-actions.open
              span.arrow
              span {{props.row.name}}
          div(
            v-else
            :class="getItemClass(props.row)"
          ).item
            span.arrow
            span {{props.row.name}}
</template>

<script>
  import {atu} from '../../../api/api-endpoints'
  import {LEVEL_CSS_CLASS_MAP} from "../../../config/config"

  export default {
    name: "ierarchy-locations-table",
    props: {
      fields: {
        type: Object
      }
    },
    computed: {
      localityVisibleColumns () {
        return {
          name: {label: 'Населенный пункт'},
          type: {label: 'Тип населенного пункта'}
        }
      }
    },
    methods: {
      isOpened (item) {
        let items = {data: []}
        if (this.$refs.localityTable) {
          items = this.$refs.localityTable.items
        }
        return items.data.findIndex(v => v.parent_id === item.id) > -1
      },
      openChild (row) {
        if (this.isOpened(row)) {
          return false
        }

        const {url: endpoint} = this.endpointLocalityList(this.$refs.localityTable)

        this.$bar.start()
        this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.atuObjects({
            query: {
              parent_id: row.id,
              'per-page': -1
            }
          }),
          useCache: true,
          params: {
            disableGlobalError: true
          }
        }).then(response => {
          let parentLvl = row.lvl || 1
          response.data.data.forEach((v, i) => {
            response.data.data[i].lvl = parentLvl + 1
          })
          this.$store.commit('mutateEndpoint', {
            endpoint,
            action: 'insertAfter',
            id: row.id,
            response
          })
          this.$bar.finish()
          this.$refs.localityTable && this.$refs.localityTable.update(endpoint)
        }).catch(e => {
          this.showOnError(e)
          this.$bar.finish()
        })
      },
      endpointLocalityList () {
        let route = {
          query: {
            parent_id: this.fields.id,
            'per-page': -1
          }
        }

        return {
          url: atu.atuObjects(route)
        }
      },
      closeChild (row) {
        let ids = []
        this.$refs.localityTable.items.data.forEach(v => {
          if (v.parent_id === row.id) {
            ids.push(v.id)
            this.closeChild(v)
          }
        })

        const {url: endpoint} = this.endpointLocalityList(this.$refs.localityTable)

        this.$store.dispatch('deleteModels', {
          endpoint,
          ids: ids,
          offline: true
        })
      },
      getItemClass (item) {
        let lvl = +(item.lvl || 1)
        if (LEVEL_CSS_CLASS_MAP[lvl]) {
          return LEVEL_CSS_CLASS_MAP[lvl]
        }
        return ''
      }
    }
  }
</script>

<style lang="scss">
  .ierarchy-locations-table{
    .sortable{
      &.arrows{
        display: none;
      }
    }
  }
</style>
